var React = require('react');

function ChevronUpDuotone (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","d":"M69.66 381.49a23.93 23.93 0 0 1-33.84 0l-22.65-22.7a24 24 0 0 1 0-33.94l154.04-154.31 56.89 56.78z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","d":"M435 358.75l-22.65 22.7a23.92 23.92 0 0 1-33.84 0l-211.34-211 40-40a23.93 23.93 0 0 1 33.84 0L435 324.81a24 24 0 0 1 0 33.94z","key":1})]));
}

ChevronUpDuotone.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"chevron-up","className":"svg-inline--fa fa-chevron-up fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = ChevronUpDuotone;

ChevronUpDuotone.default = ChevronUpDuotone;
